module.exports = __webpack_public_path__ + "img/36ne.2d6d31b4.svg";